var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-gray2" }, [
    _vm.mobiles.length > 0
      ? _c("div", { staticClass: "container-fluid" }, [
          _c(
            "div",
            { staticClass: "d-none d-xxl-block py-2 mb-3 mt-2 grid-4col" },
            [
              _c("h2", { staticClass: "no-signature" }, [
                _vm._v(
                  "\n                " + _vm._s(_vm.title) + "\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.mobiles, function (device, index) {
                  return _c(
                    "div",
                    { key: device.name, staticClass: "col-3" },
                    [
                      _c("device-history", {
                        attrs: {
                          "track-zone": _vm.trackZone,
                          device: device,
                          intention: _vm.intention,
                          index: index + 1,
                          "is-from-mobile-detail": _vm.isFromMobileDetail,
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "d-xxl-none swiper-1row py-2 mb-3 mt-2" }, [
            _c("h2", { staticClass: "no-signature mb-1" }, [
              _vm._v(
                "\n                " + _vm._s(_vm.title) + "\n            "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "ob1-carrousel swiper-container history-swiper-container",
              },
              [
                _c(
                  "div",
                  { staticClass: "swiper-wrapper" },
                  _vm._l(_vm.mobiles, function (device, index) {
                    return _c(
                      "div",
                      { key: device.name, staticClass: "swiper-slide" },
                      [
                        _c("device-history", {
                          attrs: {
                            "track-zone": _vm.trackZone,
                            device: device,
                            intention: _vm.intention,
                            index: index + 1,
                            "is-from-mobile-detail": _vm.isFromMobileDetail,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
              ]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "swiper-button-prev",
        attrs: { title: "Slide précédente", tabindex: "-1" },
      },
      [
        _c("span", { staticClass: "visually-hidden" }, [
          _vm._v("Slide précédente"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "swiper-button-next",
        attrs: { title: "Slide suivante", tabindex: "-1" },
      },
      [
        _c("span", { staticClass: "visually-hidden" }, [
          _vm._v("Slide suivante"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }